import Vue from 'vue'
import Router from 'vue-router'
import common from '../util/common'

const home = () => import('@/vue-pages/pages/home')
const classify = () => import('@/vue-pages/pages/classify')
const cart = () => import('@/vue-pages/pages/cart')
const user = () => import('@/vue-pages/pages/user')
const download_app = () => import('@/vue-pages/pages/download_app')
const product_gift_list = () => import('@/vue-pages/pages/product_gift_list')
const product_rank_list = () => import('@/vue-pages/pages/product_rank_list')
const search = () => import('@/vue-pages/pages/search')
const product_list = () => import('@/vue-pages/pages/product_list')
const product_details = () => import('@/vue-pages/pages/product_details')
const to_cart = () => import('@/vue-pages/pages/to_cart')
const submit_order = () => import('@/vue-pages/pages/submit_order')
const pay_pacypay_result = () => import('@/vue-pages/pages/pay_pacypay_result')
const pay_pacypay = () => import('@/vue-pages/pages/pay_pacypay')
const pay_success = () => import('@/vue-pages/pages/pay_success')
const pay_error = () => import('@/vue-pages/pages/pay_error')
const set_up = () => import('@/vue-pages/pages/set_up')
const set_user = () => import('@/vue-pages/pages/set_user')
const my_address = () => import('@/vue-pages/pages/my_address')
const add_address = () => import('@/vue-pages/pages/add_address')
const change_address = () => import('@/vue-pages/pages/change_address')
const my_coupon = () => import('@/vue-pages/pages/my_coupon')
const my_order = () => import('@/vue-pages/pages/my_order')
const order_list = () => import('@/vue-pages/pages/order_list')
const after_sale = () => import('@/vue-pages/pages/after_sale')
const refund = () => import('@/vue-pages/pages/refund')
const exchange = () => import('@/vue-pages/pages/exchange')
const after_sale_record = () => import('@/vue-pages/pages/after_sale_record')
const contact_us = () => import('@/vue-pages/pages/contact_us')
const about_shipping = () => import('@/vue-pages/pages/about_shipping')
const about_payment = () => import('@/vue-pages/pages/about_payment')
const terms = () => import('@/vue-pages/pages/terms')
const policy = () => import('@/vue-pages/pages/policy')
const explanation = () => import('@/vue-pages/pages/explanation')
const return_policy = () => import('@/vue-pages/pages/return_policy')
const company_profile = () => import('@/vue-pages/pages/company_profile')
const intellectual_property = () => import('@/vue-pages/pages/intellectual_property')

/**
 * 重写路由的push方法
 * 路由跳转时 “点击两次路由切换会报错（同一路由多次添加）”
 */
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(Router)

const router = new Router({
    mode: common.isApp() ? 'hash' : 'history', // 判断当前是在网页中还是app中
    base: '/',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (to.hash) {
            return {
                selector: to.hash
            }
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '*',
            redirect: '/home', // 默认路由
            component: home
        }, {
            path: '/home',
            name: 'home',
            component: home, // 首页
            meta: {
                keepAlive: true
            }
        }, {
            path: '/classify',
            name: 'classify',
            component: classify, // 分类
            meta: {
                keepAlive: true
            }
        }, {
            path: '/cart',
            name: 'cart',
            component: cart, // 购物车
            meta: {
                keepAlive: true
            }
        }, {
            path: '/user',
            name: 'user',
            component: user, // 查货
            meta: {
                keepAlive: true
            }
        }, {
            path: '/download_app',
            name: 'download_app',
            component: download_app // 下载app
        }, {
            path: '/product_gift_list',
            name: 'product_gift_list',
            component: product_gift_list, // 商品赠品列表
            meta: {
                keepAlive: true,
                isBack: false // 判断是不是返回操作
            }
        }, {
            path: '/product_rank_list',
            name: 'product_rank_list',
            component: product_rank_list, // 商品排行列表
            meta: {
                keepAlive: true,
                isBack: false // 判断是不是返回操作
            }
        }, {
            path: '/search',
            name: 'search',
            component: search, // 搜索
            meta: {
                keepAlive: true,
                isBack: false // 判断是不是返回操作
            }
        }, {
            path: '/product_list',
            name: 'product_list',
            component: product_list, // 商品列表
            meta: {
                keepAlive: true,
                isBack: false // 判断是不是返回操作
            }
        }, {
            path: '/product_details',
            name: 'product_details',
            component: product_details // 商品详情
        }, {
            path: '/to_cart',
            name: 'to_cart',
            component: to_cart // 二级购物车
        }, {
            path: '/submit_order',
            name: 'submit_order',
            component: submit_order // 提交订单
        }, {
            path: '/pay_pacypay_result',
            name: 'pay_pacypay_result',
            component: pay_pacypay_result // pacypay支付结果页（3ds验证使用）
        }, {
            path: '/pay_pacypay',
            name: 'pay_pacypay',
            component: pay_pacypay // pacypay支付页（app使用）
        }, {
            path: '/pay_success',
            name: 'pay_success',
            component: pay_success // 下单成功
        }, {
            path: '/pay_error',
            name: 'pay_error',
            component: pay_error // 下单失败
        }, {
            path: '/set_up',
            name: 'set_up',
            component: set_up // 设置
        }, {
            path: '/set_user',
            name: 'set_user',
            component: set_user // 个人信息
        }, {
            path: '/my_address',
            name: 'my_address',
            component: my_address // 地址管理
        }, {
            path: '/add_address',
            name: 'add_address',
            component: add_address // 新增地址
        }, {
            path: '/change_address',
            name: 'change_address',
            component: change_address // 修改地址
        }, {
            path: '/my_coupon',
            name: 'my_coupon',
            component: my_coupon // 我的优惠券
        }, {
            path: '/my_order',
            name: 'my_order',
            component: my_order, // 我的订单
            meta: {
                keepAlive: true,
                isBack: false // 判断是不是返回操作
            }
        }, {
            path: '/order_list',
            name: 'order_list',
            component: order_list, // 查询订单
            meta: {
                keepAlive: true,
                isBack: false // 判断是不是返回操作
            }
        }, {
            path: '/after_sale',
            name: 'after_sale',
            component: after_sale // 售后服务
        }, {
            path: '/refund',
            name: 'refund',
            component: refund // 退货退款
        }, {
            path: '/exchange',
            name: 'exchange',
            component: exchange // 换货
        }, {
            path: '/after_sale_record',
            name: 'after_sale_record',
            component: after_sale_record // 售后记录
        }, {
            path: '/contact_us',
            name: 'contact_us',
            component: contact_us // 联系我们
        }, {
            path: '/about_shipping',
            name: 'about_shipping',
            component: about_shipping // 关于运送
        }, {
            path: '/about_payment',
            name: 'about_payment',
            component: about_payment // 关于付款方式
        }, {
            path: '/terms',
            name: 'terms',
            component: terms // 服务条款
        }, {
            path: '/policy',
            name: 'policy',
            component: policy // 隐私政策
        }, {
            path: '/explanation',
            name: 'explanation',
            component: explanation // 常见问题
        }, {
            path: '/return_policy',
            name: 'return_policy',
            component: return_policy // 换货/退货政策
        }, {
            path: '/company_profile',
            name: 'company_profile',
            component: company_profile // 公司简介
        }, {
            path: '/intellectual_property',
            name: 'intellectual_property',
            component: intellectual_property // 知识产权
        }
    ]
})

router.beforeEach((to, from, next) => {
    // 修改页面title
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js